import React, { useState } from "react";
import { View, Text, ScrollView, StyleSheet } from "react-native";
import BouncyCheckbox from "react-native-bouncy-checkbox";
import { Button } from "../../../components/core/Button";
import FastImage from "../../../common/FastImage";
import Colors from "../../../assets/Color/Colors";
import { globalFontStyle } from "../../../assets";
import { globalConfigurableData } from "../../../utils/globalConstant";
import ProfileFill from "./ProfileFill";

const ConsentForm = ({ onFinalFormAccept, country }) => {
  
  const [isCheckBoxSelected, setIsCheckboxSelected] = useState(false);
  const [step, setStep] = useState(0); // 0 = ProfileFill, 1 = Consent Screen
  const [profileData, setProfileData] = useState({}); // Initialize profile data with an empty object

  const handleCheckbox = () => {
    setIsCheckboxSelected(!isCheckBoxSelected);
  };

  const onBtnClick = () => {
    onFinalFormAccept(true, 'en-IN', profileData);
  };

  const onProfileComplete = (data) => {
    setProfileData(data); // Set the profile data in state
    setStep(1); // Move to Consent Screen
  };

  return (
    <View style={{ flex: 1, backgroundColor: Colors.bgWhite }}>
      {step === 0 ? (
        <ProfileFill setProfileFields={onProfileComplete} onAgeConfirmClick={onProfileComplete} ipSelectedCountry={country} />
      ) : (
        <View style={{ flex: 1 }}>
          <ScrollView style={styles.scrollContainer} showsVerticalScrollIndicator={false}>
            <View style={styles.mainContainer}>
              {/* Logo */}
              <View style={styles.logoContainer}>
                <FastImage style={styles.logo} source={globalConfigurableData?.logoUrl()} />
              </View>

              {/* Header */}
              <View style={styles.headerContainer}>
                <Text style={styles.headerTitle}>User Agreement</Text>
                <Text style={styles.headerSubtext}>
                  Please read and accept the terms before proceeding.
                </Text>
              </View>

              {/* Combined Consent Content */}
              <Text style={styles.contentText}>
                To use this platform, you confirm that:
                {"\n\n"}• You are 18 years or older.
                {"\n"}• You understand that our platform does not promote or support betting.
                {"\n"}• You acknowledge that accounts violating platform policies may be restricted.
                {"\n"}• You agree to comply with all platform rules and regulations.
              </Text>

              <Text style={[styles.contentText, { marginTop: 5 }]}>
                Prohibited activities include:
              </Text>

              {[
                "Sharing false information",
                "Engaging in suspicious activity",
                "Using automated bots",
                "Attempting unauthorized access",
              ].map((text, i) => (
                <View key={i} style={styles.bulletPoint}>
                  <Text style={styles.bullet}>•</Text>
                  <Text style={styles.bulletText}>{text}</Text>
                </View>
              ))}
            </View>
          </ScrollView>

          {/* Bottom Section with Checkbox & Button */}
          <View style={styles.bottomContainer}>
            <View style={styles.checkboxContainer}>
              <BouncyCheckbox
                size={20}
                fillColor={globalConfigurableData.primaryTextColor1}
                unfillColor="#FFFFFF"
                iconStyle={{ borderColor: "red", borderRadius: 5 }}
                innerIconStyle={{ borderWidth: 1, borderRadius: 5 }}
                onPress={handleCheckbox}
                isChecked={isCheckBoxSelected}
              />
              <Text style={styles.checkboxText}>
                I confirm that I am 18+ years old and agree to the terms above.
              </Text>
            </View>

            <Button variant="primary" disabled={!isCheckBoxSelected} onPress={onBtnClick}>
              Proceed
            </Button>
          </View>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    paddingBottom: 100, // Extra padding to keep content visible above bottom container
  },
  logoContainer: {
    paddingVertical: 30,
    alignItems: "center",
  },
  logo: {
    height: 30,
    width: 80,
  },
  headerContainer: {
    marginBottom: 24,
  },
  headerTitle: {
    ...globalFontStyle.appFontEventTitle,
    fontSize: 24,
    fontWeight: "600",
    color: globalConfigurableData.primaryTextColor1,
    marginBottom: 8,
  },
  headerSubtext: {
    ...globalFontStyle.appFontSubText,
    fontSize: 14,
    lineHeight: 20,
    color: globalConfigurableData.secondaryTextColor1,
    opacity: 0.8,
  },
  scrollContainer: {
    flex: 1,
  },
  contentText: {
    ...globalFontStyle.appFontBody,
    color: globalConfigurableData.primaryTextColor1,
    lineHeight: 20,
  },
  bulletPoint: {
    flexDirection: "row",
    alignItems: "flex-start",
    paddingVertical: 8,
  },
  bullet: {
    ...globalFontStyle.appFontBody,
    color: globalConfigurableData.primaryTextColor1,
    marginRight: 8,
    fontSize: 16,
  },
  bulletText: {
    flex: 1,
    ...globalFontStyle.appFontBody,
    color: globalConfigurableData.primaryTextColor1,
  },
  bottomContainer: {
    position: "sticky",
    bottom: 10,
    left: 0,
    right: 0,
    backgroundColor: Colors.bgWhite,
    zIndex: 1,
  },
  checkboxContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 15,
  },
  checkboxText: {
    flex: 1,
    ...globalFontStyle.appFontSmallText,
    color: globalConfigurableData.secondaryTextColor1,
  },
});

export default ConsentForm;
